import { Button } from '../../../common';
import styled from 'styled-components';

export const SectionTitle = styled.h4`
  font-size: 18px;
  color: ${(props) => props.theme.colors.textBold};
  font-weight: 700;
  margin-bottom: 16px;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  gap: 8px;
`;

export const CardConfirmationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  background-color: #fff;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 8px;
`;

export const IconWrapper = styled.div`
  color: white;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 2px solid ${({ borderColor }) => borderColor};

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

TextWrapper.Title = styled.span`
  font-weight: 700;
  font-size: 0.75rem;
  color: ${(props) => props.color};
`;

TextWrapper.Description = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.color};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

ActionsWrapper.ActionButton = styled(Button)`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 10px;
  cursor: pointer;
  border: none;
  background-color: transparent !important;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto !important')};
  min-width: 60px;
  border: 2px solid;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;

  @media (min-width: 768px) {
    font-size: 10px;
  }

  &[disabled] {
    opacity: 0.4;
  }

  &.back {
    color: #949494;
    border-color: #949494;
  }

  &.error {
    color: #ff4949;
    border-color: #ff4949;
  }
`;
